import * as R from 'ramda'
import * as recompose from 'recompose'
import { connect } from 'react-redux'

import * as casino from '@rushplay/casino'

import * as configuration from './configuration'
import { ClientType } from './constants'

function mapStateToProps(state, props) {
  const clientType = configuration.getClientType(state.configuration)
  const isMobile = R.includes(clientType, [
    ClientType.MOBILE_BROWSER,
    ClientType.IOS,
  ])

  return {
    clientType,
    mountPoint: 'casino',
    params: R.assoc('mobile', isMobile, props.params),
  }
}

const connector = R.compose(
  connect(mapStateToProps, null),
  recompose.branch(
    props => R.equals(props.clientType, ClientType.UNKNOWN),
    recompose.renderNothing
  )
)

export const GameQuery = connector(casino.GameQuery)
